export const WIFI_DIRECT_HOST = '192.168.89.136';
export const WIFI_DIRECT_BASE_URL = 'https://192.168.89.136';
export const DEFAULT_PIN_CODE = '123456';
